import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { addRestaurant } from "./Resturant.action";
import { setHeading } from "../../../accounts/account.actions";
import { addProductImage } from "../AddProduct/Product.action";
import { ToggleButton, ToggleButtonGroup, Button } from "@mui/material";
import Select from "react-select";
import SendIcon from "@mui/icons-material/Send";
import ImageUploader from "react-images-upload";


const AddResturant = (props) => {
  const initialFormState = {
    restaurantName: "",
    restaurantLocation: "",
    restaurantDesc: "",
    tax: 0,
    ntn: "",
    phone: "",
    email: "",
    strn: "",
    praTaxCash: 0,
    praTaxCard: 0,
    fbrTaxCash: 0,
    fbrTaxCard: 0,
    taxType: "PRATax",
    sandBoxToken: "",
    productiontoken: "",
  };
  const [form, setForm] = useState(initialFormState);
  const [province, setProvince] = useState();

  useEffect(() => {
    props.setHeading("Add Company");
  }, []);

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
  };

  const handleSwitch = (e, value) => {
    if (value) {
      setForm({ ...form, taxType: value });
    }
  };

  const SaveRestaurant = () => {
    props.addRestaurant(
      {
        ...form,
        province,
        image: props.ProductImageURL.file
      },
      (msg) => {
        showSuccessAlert(msg);
        setForm(initialFormState);
        props.ProductImage({ image: "" });
      },
      showErrorAlert
    );
  };

  const onDrop = (pictureFiles) => {
    props.ProductImage({
      image: pictureFiles[0]
    });
  };


  let provinces = [{
    value: "PUNJAB",
    label: "PUNJAB"
  },
  {
    value: "BALOCHISTAN",
    label: "BALOCHISTAN"
  },
  {
    value: "AZAD JAMMU AND KASHMIR",
    label: "AZAD JAMMU AND KASHMIR"
  },
  {
    value: "CAPITAL TERRITORY",
    label: "CAPITAL TERRITORY"
  },
  {
    value: "KHYBER PAKHTUNKHWA",
    label: "KHYBER PAKHTUNKHWA"
  },
  {
    value: "SINDH",
    label: "SINDH"
  },
  {
    value: "GILGIT BALTISTAN",
    label: "GILGIT BALTISTAN"
  }];
  const handleChangeProvince = (selectedOption) => {
    setProvince(selectedOption.label);
  };
  const GetProvinceList = provinces.map((x) => {
    let data = { value: x.value, label: x.label };
    return data;
  });

  const isPRATax = form.taxType === "PRATax";

  return (
    <>
      {props.isAddingRestaurant ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Form>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Company Name *</b></Form.Label>
                  <Form.Control
                    placeholder="Company Name"
                    onChange={handleChange("restaurantName")}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Company Location</b></Form.Label>
                  <Form.Control
                    placeholder="Company Location"
                    onChange={handleChange("restaurantLocation")}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>NTN Number *</b></Form.Label>
                  <Form.Control
                    type="number"
                    value={form.ntn}
                    onChange={handleChange("ntn")}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Phone *</b></Form.Label>
                  <Form.Control
                    value={form.phone}
                    onChange={handleChange("phone")}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Email *</b></Form.Label>
                  <Form.Control
                    value={form.email}
                    onChange={handleChange("email")}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>STRN</b></Form.Label>
                  <Form.Control
                    type="number"
                    value={form.strn}
                    onChange={handleChange("strn")}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Description</b></Form.Label>
                  <Form.Control
                    value={form.restaurantDesc}
                    onChange={handleChange("restaurantDesc")}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Tax Amount</b></Form.Label>
                  <Form.Control
                    type="number"
                    value={form.tax}
                    onChange={handleChange("tax")}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Province *</b></Form.Label>
                  <Select
                    placeholder="Select Province"
                    onChange={handleChangeProvince}
                    options={GetProvinceList}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>FBR SandBox Token *</b></Form.Label>
                  <Form.Control
                    value={form.sandBoxToken}
                    onChange={handleChange("sandBoxToken")}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>FBR Production Token *</b></Form.Label>
                  <Form.Control
                    value={form.productiontoken}
                    onChange={handleChange("productiontoken")}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col style={{ marginBottom: '20px' }}>
                <Form.Label><b>Select Tax Type</b></Form.Label>
                <br />
                <ToggleButtonGroup value={form.taxType} exclusive onChange={handleSwitch}>
                  <ToggleButton value="PRATax"><b>PRA TAX</b></ToggleButton>
                  <ToggleButton value="FBRTax"><b>FBR TAX</b></ToggleButton>
                </ToggleButtonGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>PRA Tax on Cash</b></Form.Label>
                  <Form.Control
                    type="number"
                    disabled={!isPRATax}
                    value={form.praTaxCash}
                    onChange={handleChange("praTaxCash")}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>PRA Tax on Card</b></Form.Label>
                  <Form.Control
                    type="number"
                    disabled={!isPRATax}
                    value={form.praTaxCard}
                    onChange={handleChange("praTaxCard")}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>FBR Tax on Cash</b></Form.Label>
                  <Form.Control
                    type="number"
                    disabled={isPRATax}
                    value={form.fbrTaxCash}
                    onChange={handleChange("fbrTaxCash")}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>FBR Tax on Card</b></Form.Label>
                  <Form.Control
                    type="number"
                    disabled={isPRATax}
                    value={form.fbrTaxCard}
                    onChange={handleChange("fbrTaxCard")}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label><b>Upload Company Logo *</b></Form.Label>
                <ImageUploader
                  withIcon={false}
                  buttonText="Upload Logo"
                  onChange={onDrop}
                  imgExtension={[".jpg", ".png", ".gif"]}
                  maxFileSize={5242880}
                  singleImage
                  withPreview
                />
              </Col>
            </Row>

            <div className="sendDiv" >
              <Button variant="contained" endIcon={<SendIcon />} size="large"
                disabled={
                  isEmpty(form.restaurantName) || isEmpty(form.ntn) || isEmpty(form.phone) || isEmpty(form.email) || isEmpty(province)
                  // isEmpty(props.ProductImageURL.file)
                }
                onClick={SaveRestaurant}
              >
                SAVE
              </Button>
            </div>

          </Form>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  addRestaurant: (data, success, error) => dispatch(addRestaurant(data, success, error)),
  setHeading: (data) => dispatch(setHeading(data)),
  ProductImage: (data) => dispatch(addProductImage(data))
});

const mapStateToProps = (state) => ({
  isAddingRestaurant: state.ResturantReducer.isAddingRestaurant,
  ProductImageURL: state.ProductReducer.ProductImageURL
});

export default connect(mapStateToProps, mapDispatchToProps)(AddResturant);